import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Flame, Clock } from "lucide-react";
import http from "@/api";
import { useApp } from "@/context";
import ProductCard from "@/components/ProductCard";

function useMidnightCountdown() {
  const [left, setLeft] = useState("");
  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const mid = new Date(now);
      mid.setHours(24, 0, 0, 0);
      const s = Math.max(0, Math.floor((mid - now) / 1000));
      const pad = (n) => String(n).padStart(2, "0");
      setLeft(`${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);
  return left;
}

export default function TodaysOffers() {
  const { lang } = useApp();
  const [offers, setOffers] = useState([]);
  const countdown = useMidnightCountdown();

  useEffect(() => {
    http.get("/products/offers?limit=12")
      .then(({ data }) => setOffers(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, []);

  if (!offers.length) return null;

  return (
    <motion.section
      initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
      className="relative overflow-hidden rounded-[1.5rem] p-4 sm:p-5"
      style={{ background: "var(--surface-invert)" }}
      data-testid="todays-offers-section"
    >
      <div className="pointer-events-none absolute -top-10 -end-10 w-40 h-40 rounded-full opacity-10"
           style={{ background: "radial-gradient(circle, #fff, transparent 70%)" }} />

      <div className="flex items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2 text-white">
          <span className="w-9 h-9 rounded-full flex items-center justify-center"
                style={{ background: "rgba(255,255,255,0.12)" }}>
            <Flame size={18} className="text-white" fill="currentColor" />
          </span>
          <div>
            <h2 className="text-base md:text-lg font-bold leading-tight"
                data-testid="todays-offers-title">
              {lang === "ar" ? "عروض اليوم" : "Today's Offers"}
            </h2>
            <div className="text-[11px] text-white/75">
              {lang === "ar" ? "خصومات حقيقية لفترة محدودة" : "Real discounts, limited time"}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-bold text-white shrink-0"
             style={{ background: "rgba(255,255,255,0.12)", fontVariantNumeric: "tabular-nums" }}
             data-testid="todays-offers-countdown">
          <Clock size={13} className="text-white/80" />
          <span dir="ltr">{countdown}</span>
        </div>
      </div>

      <div className="flex gap-3 overflow-x-auto pb-1 -mx-1 px-1 snap-x"
           style={{ scrollbarWidth: "none" }}
           data-testid="todays-offers-scroll">
        {offers.map((p) => (
          <div key={p.id} className="w-40 sm:w-48 shrink-0 snap-start">
            <ProductCard product={p} />
          </div>
        ))}
      </div>
    </motion.section>
  );
}
